import { Box, CheckIcon } from '../../Material/index'
import IconButton from 'components/Material/IconButton'
import useDocumentsStore, { FileStatus } from 'store/useDocuments'
import TrashCan from 'assets/icons/TrashCan'
import colors from 'colors'
import React from 'react'

type FileState = {
  status: FileStatus
  file: globalThis.File | null
}
type DocumentListItemProps = {
  document: FileState
  documentId: number
  input: React.RefObject<HTMLInputElement>
  isLoading: boolean
}

export const DocumentListItem = ({
  document,
  documentId,
  input,
  isLoading
}: DocumentListItemProps) => {
  const { setDocumentFile, setDocumentProgress } = useDocumentsStore((state) => state)
  const clearDocument = () => {
    setDocumentFile({ id: documentId, newFile: null })
    setDocumentProgress({ id: documentId, newProgress: 0 })
    if (input.current) {
      input.current.value = ''
    }
  }

  return (
    <Box className="flex justify-between px-4 mb-6">
      <CheckIcon className="text-blue-bb" />
      {document?.file?.name && <Box>{document.file.name}</Box>}

      {!isLoading && (
        <IconButton
          title="Excluir"
          className="cursor-pointer"
          onClick={() => {
            clearDocument()
          }}
        >
          <TrashCan colors={colors['blue-bb']} />
        </IconButton>
      )}
    </Box>
  )
}
